/**
 * The shape every direction file fills in (P0-9 deliverable 1). One file per
 * direction, so the directions that lose at the design gate can be deleted
 * cleanly.
 */
export const DIRECTION_IDS = ['atlas', 'ledger', 'noir'];
export const MODES = ['dark', 'light'];
export const DENSITIES = ['compact', 'comfortable', 'table'];
/** Core tokens, in the order the tokens strip shows them. */
export const CORE_TOKENS = [
    'bg',
    'surface',
    'surfaceRaised',
    'border',
    'borderStrong',
    'controlBorder',
    'text',
    'textMuted',
    'accent',
    'accentContrast',
    'danger',
    'success',
    'ai',
];
/** The fourteen built-in document types, in sidebar order. */
export const BUILT_IN_TYPES = [
    'pc',
    'npc',
    'creature',
    'encounter',
    'location',
    'faction',
    'item',
    'lore',
    'arc',
    'quest',
    'script',
    'session',
    'spell',
    'note',
];
/**
 * User-defined types the design system draws with a glyph and a color token
 * of their own: the demo campaign's Deity. The GM decided on 2026-09-28
 * (docs/PLAN.md section 2) that Deity gets its own glyph and a pale
 * silver-white hue. A direction lists the user types it gives a hue in
 * `userTypeHues`; any other user type equals `textMuted` there and takes the
 * neutral note treatment (never tinted).
 */
export const USER_TYPES = ['deity'];
/** Every type with a glyph and a color token: the built-in types, then the user types. */
export const TYPE_KEYS = [...BUILT_IN_TYPES, ...USER_TYPES];
export const HUED_TYPES = BUILT_IN_TYPES.filter((t) => t !== 'note');
/** The three content surfaces every text color is checked against. */
export const SURFACES = ['bg', 'surface', 'surfaceRaised'];
/**
 * Notion's nine colors, the names and order of `NOTION_COLORS` in
 * @codex/contracts (written out: the kit does not import contracts at
 * runtime; palette.test.ts holds them equal). Pasted text colors, highlights
 * and callouts use them.
 */
export const PALETTE_COLORS = [
    'gray',
    'brown',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'pink',
    'red',
];
/** The direction the app uses when none is chosen: Grimoire Noir (docs/PLAN.md section 2). */
export const DEFAULT_DIRECTION = 'noir';
/** The types a direction checks and tints as hues: the thirteen built-in hues, then its hued user types. */
export function huedTypes(direction) {
    return [...HUED_TYPES, ...direction.userTypeHues];
}
/** Whether `type` has a hue of its own in `direction` (otherwise it takes the neutral note treatment). */
export function typeHasHue(direction, type) {
    return huedTypes(direction).includes(type);
}
//# sourceMappingURL=types.js.map